// extracted by mini-css-extract-plugin
module.exports = {"Title":"Patients_Title__1XWbY","SaveButton":"Patients_SaveButton__2dibC"};